'use strict';
var parent = require('../../es/instance/filter');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/filter.js
// module id = 762
// module chunks = 13